import { ReactNode } from "react";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";

export function SupplierOnly(props: { children?: ReactNode }) {
  const { business } = useSellarCurrentBusiness();

  if (business?.Supplier) return <>{props.children}</>;
  return null;
}
